import { StrictMode } from "react";
import { createRoot, type Root } from "react-dom/client";
import App from "./App";
import { ErrorBoundary } from "./components/ErrorBoundary";
import "./index.css";
import "@/lib/firebase";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element #root not found");

// Editing a non-component module this tree imports (e.g. a Zustand store)
// can't be fast-refreshed in place, so Vite re-executes this entry instead.
// Without reusing the root across that re-execution, createRoot() mounts a
// second React tree over the same DOM node — the whole UI renders doubled.
// import.meta.hot.data survives HMR re-runs of this module; reuse it.
let root: Root;
if (import.meta.hot?.data.root) {
  root = import.meta.hot.data.root as Root;
} else {
  root = createRoot(rootEl);
  if (import.meta.hot) import.meta.hot.data.root = root;
}

root.render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
